import { put, call } from 'redux-saga/effects';
import { showAlert } from 'actions/index';
import { ActionTypes } from 'constants/index';

export function* getSearchSuggestions(api, action) {
  const response = yield call(api.getSearchSuggestions, action.payload);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.GET_SEARCH_SUGGESTIONS_SUCCESS,
      payload: data,
    });
  } else {
    const { errors } = data || {};
    yield put({
      type: ActionTypes.GET_SEARCH_SUGGESTIONS_FAILURE,
    });
    if (status !== 500 && status !== 401) {
      yield put(
        showAlert((errors && errors.message) || 'Search failed', {
          variant: 'danger',
          timeout: 5,
        }),
      );
    }
  }
}
